export default __webpack_public_path__ + "static/media/wallet.2d6239fc.webp";